module.exports = __webpack_public_path__ + "media/images/team__smashgc-b3d99a53d84e33bd1839522218f4556b.png";